export default "__VITE_ASSET__D0t$e24s__"